import React from 'react'
import YouTube from 'react-youtube'

function getYoutubeVideoId(url) {
  if (!url) {
    return false
  }

  var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
  var match = url.match(regExp)
  if (match && match[2].length == 11) {
    return match[2]
  } else {
    return false
  }
}

const YoutubeEmbed = ({ block }) => {
  const videoId = getYoutubeVideoId(block.attrs.url)

  if (!videoId) {
    return null
  }

  return (
    <figure
      className={`wp-block-embed-youtube ${
        block.attrs.align === 'center' ? 'aligncenter' : ''
      } wp-block-embed is-type-video wp-embed-aspect-16-9`}
    >
      <YouTube videoId={videoId} />
    </figure>
  )
}

export default YoutubeEmbed
